export default __webpack_public_path__ + "static/media/Standard Application.51f71b0e.pdf";